/** Initials-only avatar — no images, no external APIs. */

export function getInitials(name = "") {
    return String(name)
        .split(" ")
        .filter(Boolean)
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2) || "?";
}

export function InitialsAvatar({ name, className = "h-10 w-10", accentColor }) {
    return (
        <span
            className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full border border-white/10 bg-[#262626] text-sm font-semibold text-white ${className}`}
            style={accentColor ? { color: accentColor } : undefined}
            aria-hidden
        >
            {getInitials(name)}
        </span>
    );
}
